var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',_vm._g(_vm._b({class:_vm.desc.class,style:(_vm.desc.style),model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'el-switch',_vm.attrs,false),_vm.onEvents))}
var staticRenderFns = []

export { render, staticRenderFns }